import { ConditionName } from "../../interfaces/enums";
import {
    handleBackwardForward,
    handleChangeSoundVolume,
    handleClickVideoCard,
    handleFullScreen,
    handleLock,
    handlePlayPause
} from "../../redux/actions/controller.actions";
import { handleClickRecommendationCard, handleSubtitle } from "../../redux/actions/videoData.actions";
import { useAppDispatch } from "../../redux/hooks";
import { setActiveElements } from "../../redux/slices/controllerSlice";
import { setClearPopoversSlice, setMarkersListPopover, setMultiLivesPopovers, setSpeedPopover } from "../../redux/slices/popoversSlice";
import store from "../../redux/store";
import { conditions } from "../conditions/conditions";
import { videoTag } from "../constants";
import useKeyPress from "./useKeyPress";

const useHandleKeyPress = () => {
    const dispatch = useAppDispatch();

    useKeyPress("Space", (event: any) => {
        if (conditions(ConditionName.isPressKeySpace)) handlePlayPause(event);
    });
    useKeyPress("KeyK", (event: any) => {
        if (conditions(ConditionName.isPressKeyK)) handlePlayPause(event);
    });
    useKeyPress("ArrowRight", (event: any) => {
        if (conditions(ConditionName.isPressKeyArrowRight)) handleBackwardForward("forward", 15, event);
    });
    useKeyPress("ArrowLeft", (event: any) => {
        if (conditions(ConditionName.isPressKeyArrowLeft)) handleBackwardForward("backward", 15, event);
    });
    useKeyPress("KeyI", () => {
        if (conditions(ConditionName.isPressKeyI)) videoTag().requestPictureInPicture();
    });
    useKeyPress("KeyF", () => {
        if (conditions(ConditionName.isPressKeyF)) handleFullScreen();
    });
    useKeyPress("KeyL", () => {
        if (conditions(ConditionName.isPressKeyL)) {
            handleLock(conditions(ConditionName.isLock) ? "unlock" : "lock");
        }
    });
    useKeyPress("KeyC", () => {
        if (conditions(ConditionName.isPressKeyC)) handleSubtitle();
    });
    useKeyPress("KeyN", () => {
        if (conditions(ConditionName.isPressKeyN)) {
            handleClickRecommendationCard();
            handleClickVideoCard();
        }
    });
    useKeyPress("KeyQ", () => {
        if (conditions(ConditionName.isPressKeyQ)) {
            const { multiLivesPopover } = store.getState().popovers;
            dispatch(setMultiLivesPopovers(!multiLivesPopover));
        }
    });
    useKeyPress("KeyE", () => {
        if (conditions(ConditionName.isPressKeyE)) {
            const { markersListPopover } = store.getState().popovers;
            dispatch(setClearPopoversSlice());
            dispatch(setMarkersListPopover(!markersListPopover));
            if (!conditions(ConditionName.isActiveElements)) dispatch(setActiveElements(true));
            else if (!conditions(ConditionName.showMarkerListPopover)) dispatch(setActiveElements(false));
        }
    });
    useKeyPress("KeyS", () => {
        const { speedPopover } = store.getState().popovers;
        dispatch(setClearPopoversSlice());
        if (conditions(ConditionName.isPressKeyS)) {
            dispatch(setSpeedPopover(!speedPopover));
            if (!conditions(ConditionName.isActiveElements)) dispatch(setActiveElements(true));
            else if (!conditions(ConditionName.showSpeedPopover)) dispatch(setActiveElements(false));
        }
    });
    useKeyPress("KeyM", () => {
        if (conditions(ConditionName.isPressKeyM)) {
            const { settings } = store.getState().user;
            handleChangeSoundVolume(settings.volume ? 0 : 50);
        }
    });
};

export default useHandleKeyPress;
